// extracted by mini-css-extract-plugin
export default {"container":"style_container__veNns","logo":"style_logo__WYOtC"};